module.exports = __webpack_public_path__ + "media/application/images/ui/icon-link-4f036b34d0e2eb8b35acce6df8e124d4.png";